import * as React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import Old2005BlogPage from "../../components/Old2005BlogPage";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—December 2006" />
	<Old2005BlogPage>
		<h2>December 2006</h2>



		<h3 className="blogdate">
		Saturday, December 16, 2006
		</h3>






		<h4 className="blogitemtitle">
		Hitchhiking and the Taliband
		</h4>





			<div className="blogitembody">
			I needed to break free from the wind of Wellington for a bit, so I hopped a ferry south.  I left the north island and arrived at a point, on the south island, that is more north than Wellington.  It's possible, I admit.<br /><br />I had a little nap on the ferry, and woke up noticing sunshine on the deck, and people appearing to be warm. I joined them and confirmed that it was warm, and the scenery was beautiful for the next hour into Picton.<br /><br />Hitchhiking out of Picton, I was passed, seemingly endlessly, by many empty vehicles.  I was starting to feel that the rumours of New Zealand being an easy place to hitch around in were false... but then a very full van pulled over for me.  On top of being completely full, it was towing a trailer.  This wildly painted van was the tour bus of Dunedin's The Taliband, a band that has been "liberating women on the dance floor since 2004."<br /><br />No sooner had I hopped into the van than a beer was passed to me, and the road into Nelson was beautiful!  We stopped for a quick jam next to a stream and it was decided that I would support their gig at Hot Mama's in Motueka the following night.  They dropped me at the visitor's center in Nelson where I was hoping to meet my friends.<br /><br />My friends had already left so I was stuck in Nelson at 8:00 pm.  I thought I'd try to hitch to Motueka, where my friends were, but I couldn't get far enough out of town to summon more than chuckles from passing drivers.  As I was walking back to find a hostel, The Taliband found me and invited me to crash with them.  We set up camp in someone's side yard over the bay and had a barbeque and played some music.<br /><br />Ultimately I found my friends in Motueka and had a good time.  It was nice to wear shorts and feel the heat of summer!  I barefooted my way through a 3 hour hike in Abel Tasman, which was incredibly beautiful!  I didn't bring my camera, sorry.  It was beautiful.  It reminded me of Krabi in Thailand with it's lush hills and golden beaches, only much cooler, cleaner, and less tropical.<br /><br />Back in Wellington, I am wearing pants, jacket, and trying to pretend that the wind is normal.
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 1:58 PM &nbsp;
			</div>






		<h3 className="blogdate">
		Sunday, December 10, 2006
		</h3>






		<h4 className="blogitemtitle">
		Behold Spartacus R
		</h4>





			<div className="blogitembody">
			It's lavishly lush and brilliant, it's Spartacus R! I saw them at the lounge-tastic Mighty Mighty tonight and it was perfect.  It's experiences like this that completely eradicate all disappointment with the icy arctic wind and variable weather that Wellington experiences at the brink of summer.  There is some formidable musical talent in this little city, and this talent will fuel my torment in the matter of staying or leaving.<br /><br />Tynan, you would have loved these guys.  Rhodes keyboard, vintage old gear that sounded like atari's with tube circuitry, sax, oboe, danelectro guitar, rockit amps, and killer bass and drums.<br /><ul><li><a href="http://www.myspace.com/spartacusr">http://www.myspace.com/spartacusr</a></li></ul>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 2:17 AM &nbsp;
			</div>






		<h3 className="blogdate">
		Sunday, December 03, 2006
		</h3>






		<h4 className="blogitemtitle">
		Years after the fire
		</h4>





			<div className="blogitembody">
			Remember the massive forest fire in Kelowna three or four years ago?  The one that burned approximately 500 homes (but left their private swimming pools in tact)?  Forests are often meant to burn, and I discovered that it's quite beautiful at one burn site above the city.  (Kelowna, Sept/Oct 2006)<br /><br />The golden grasses are a nice contrast for the charred trees.<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20061203/F1000029.jpg"
			alt="after the Kelowna fire"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />Some rusty-brown lichen or moss between the grounded trees, some green leafs in the foreground, and a slope of charred timber in behind.<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20061203/F1000027.jpg"
			alt="after the Kelowna fire"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />It no longer smells like burnt forest when you walk through.<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20061203/F1000026.jpg"
			alt="after the Kelowna fire"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />How long will this tree stand here, dead?<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20061203/F1000020.jpg"
			alt="after the Kelowna fire"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />Simon documents some charred wood, while survivors look onward behind him.<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20061203/F1000022.jpg"
			alt="after the Kelowna fire"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />I'm tickled that two friends, who have spent next-to-no time together over nearly five years, can get together and proceed as if there was no gap at all.  Simon and I are friends with a common interest in photography and the great outdoors.  Eventually you should badger me to post some photos from our excellent, Mormon-dodging adventure in Moab, Utah and Arches National Park.<br /><br />Here Simon ponders life in Kelowna, or he's just posing.<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20061203/F1000018.jpg"
			alt="after the Kelowna fire"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />Probably posing, again, or estimating the distance to the nearest black bear.<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20061203/F1000025.jpg"
			alt="after the Kelowna fire"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />Silhouettes are fun.<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20061203/F1000019.jpg"
			alt="after the Kelowna fire"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />Sorry ladies, but Simon is already is spoken for!<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20061203/F1000030.jpg"
			alt="after the Kelowna fire"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 3:17 PM &nbsp;
			</div>





		<p>
			<Link to="/blog2005/">Go back to the blog index page</Link>
		</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
